import * as Types from '../../../.cache/__types__/index';

import { gql } from '@apollo/client';
import { WorkspaceCoreFieldsFragmentDoc } from './core.graphql';
export type WorkspaceDetailsFragment = { __typename?: 'Workspace', avatar_url?: string | null, employee_count?: any | null, cards_used?: number | null, seats_used?: number | null, id: string, name?: string | null, type?: Types.WorkspaceType | null, profiles?: Array<{ __typename?: 'Profile', id: string, workspace?: { __typename?: 'Workspace', type?: Types.WorkspaceType | null, id: string } | null }> | null };

export const WorkspaceDetailsFragmentDoc = gql`
    fragment WorkspaceDetails on Workspace {
  ...WorkspaceCoreFields
  avatar_url
  employee_count
  cards_used
  seats_used
  profiles {
    id
    workspace {
      type
      id
    }
  }
}
    ${WorkspaceCoreFieldsFragmentDoc}`;